"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _plane = _interopRequireDefault(require("../../assets/images/plane.png"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _context = _interopRequireDefault(require("../../constants/context"));
var PREFIX = (0, _getPrefixCls.getPrefixCls)('input');
var Input = function Input(props) {
  var _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? _context.default.input_placeholder : _props$placeholder,
    className = props.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(PREFIX, className)
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "".concat(PREFIX, "__input"),
    placeholder: placeholder
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "__submit")
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _plane.default
  })));
};
exports.Input = Input;